// @ts-nocheck
import * as React from "react";
import { Typography, Box, Stack } from "@mui/material";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function Footer() {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('lg'));

    const FooterSection = ({ title, children }) => (
        <Stack spacing={1} p={"0 25px"} flex={1} maxWidth={"400px"}>
            <Typography variant="h6" color="primary.contrastText" gutterBottom>
                {title}
            </Typography>
            {children}
        </Stack>
    );

    return (
        <>
            <Box sx={{ height: "100px" }} />
            <Box
                component="footer"
                sx={{
                    bottom: 0,
                    width: '100%',
                    zIndex: 10,
                    position: 'fixed',
                    color: (theme) => theme.palette.primary.main,
                    backgroundColor: (theme) => theme.palette.primary.contrastText
                }}
            >
                <Divider />
                <Box
                    paddingBlock={"10px"}

                >
                    <Grid container spacing={2} direction="row"
                        sx={{
                            justifyContent: "flex-start",
                            alignItems: "center",
                            paddingLeft: "25px",
                        }} >
                        <Grid item xs={6} >
                            <Typography variant="body2">Desarrollado por  <b>SubIM</b></Typography>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </>
    );
}
